import { render, staticRenderFns } from "./RequisitesGroup.vue?vue&type=template&id=a1265016"
import script from "./RequisitesGroup.vue?vue&type=script&lang=js"
export * from "./RequisitesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports